import { Navigate } from 'react-router-dom';
import { getRoutes, ROLES } from './Routes';
import { useSelector } from 'react-redux';
import AppLayout from '../components/layout';

const ProtectedRoute = ({ allowedRoles, standalone, children }) => {
  const { user: currentUser } = useSelector((state) => state.authSlice);

  if (currentUser === undefined) {
    return <div>Loading...</div>;
  }

  if (currentUser === null || (allowedRoles && !allowedRoles.includes(currentUser.role))) {
    switch (currentUser?.role) {
      case ROLES.CUSTOMER:
        return <Navigate to={getRoutes().order.route()} replace />;
      default:
        return <div>You do not have permission to access this content.</div>;
    }
  }

  if (standalone) {
    return children;
  }

  return <AppLayout>{children}</AppLayout>;
};

export default ProtectedRoute;
